<template>
    <div class="property-examine"  style="margin-top: 10px;margin-left: 30px;">
        <el-card shadow="hover" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
            <el-row :gutter="20">
                <el-col :span="7">
                    <el-button type="primary">
                        企业认证审核
                    </el-button>
                </el-col>

            </el-row>



            <el-row :gutter="20" type="flex" justify="end">
                <el-col :span="12" v-if="currentName === ''">
                    <el-input v-model="keywords" placeholder="请输入企业名称..." style="width: 300px; float: right"
                        @keydown.enter.native="doSearch">
                        <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
                    </el-input>
                </el-col>
            </el-row>






            <component v-bind:is="currentName" @changeName="changeName"></component>
            <div class="table" v-if="currentName === ''" style="margin-top: 20px; width: 100%">
                <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#f5f5f5' }">

                    <el-table-column type="index" label="序号" width="80"  align="center">
                    </el-table-column>

                    <el-table-column prop="companyName" label="企业名称" align="center">
                    </el-table-column>

                    <el-table-column prop="socialCreditCode" label="统一信用代码" align="center">
                    </el-table-column>

                    <el-table-column prop="userId" label="企业账号" align="center">
                    </el-table-column>

                    <el-table-column prop="authState" label="认证状态" align="center">
                    </el-table-column>

                    <el-table-column prop="contactsName" label="联系人" align="center">
                    </el-table-column>

                    <el-table-column prop="contactsPhone" label="联系电话" align="center">
                    </el-table-column>

                    <el-table-column prop="createTime" label="提交时间" align="center">
                    </el-table-column>

                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="handleReview(scope.row)">审核</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
        </el-card>
        <div v-if="currentName === ''" class="block" style="position: absolute; left: 38%;margin-top: 20px">
            <el-pagination layout="prev, pager, next" :total="boardsTotal" :page-size="10" :current-page="currPage"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PublishBoard",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            keywords: '',
            currentName: '',
            tableData: [],
            columnWidth: 230,
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData(this.keywords);
        },
        initTableData(keyword) {

            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useId:  " + user.id)


            this.getRequest('/web/companyDetail/queryList?keyword=' + encodeURIComponent(keyword) + '&userId=' + user.id + '&currPage=' + this.currPage + '&pageSize=' + 10).then(resp => {
                //console.log(resp.data);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            });
        },
        doSearch() {
            this.initTableData(this.keywords);
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleEdit(obj) {
            this.currentName = 'AddBoardContent';
            this.$store.commit('ADD_CURRENT_BOARD_ID', obj.id);
        },
        handleDelete(obj) {
            this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRequest("/web/board/" + obj.id).then(resp => {
                    this.initTableData('');
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {
            });
        },
        goToRegistration() {
            this.$router.push('/index/data-registration');
        },
        handleQuery(row) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }

                this.$router.push({
                    path: '/index/company/detail',
                    query: {
                        formData: JSON.stringify(row)
                    }
                });
            } catch (error) {
                console.error('跳转详情页面失败:', error);
                this.$message.error('跳转详情页面失败: ' + error.message);
            }
        },
        handleReview(row) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }

                this.$router.push({
                    path: '/index/company/company-review',
                    query: {
                        companyId: row.companyId || row.companyId
                    }
                });
            } catch (error) {
                console.error('跳转审核页面失败:', error);
                this.$message.error('跳转审核页面失败: ' + error.message);
            }
        }
    }
}
</script>

<style>
/* 表头样式 */
.property-examine .el-table__header th {
    text-align: center;
    font-size: 14px;
    color: rgb(46, 44, 44);
    background-color: #f5f5f5 !important;
}


</style>